// Soporte (Tawk.to): chat en vivo + Centro de ayuda (knowledge base).
//
// ⚠️ COMPLETAR con la cuenta Tawk PROPIA (no la de Voras/socios):
//   1. Crear cuenta gratis en tawk.to → Add Property.
//   2. Administration → Chat Widget → copiar Property ID y Widget ID del snippet
//      (https://embed.tawk.to/<PROPERTY_ID>/<WIDGET_ID>).
//   3. Activar Knowledge Base y elegir el subdominio (ej. <nombre>.tawk.help).
// Con los valores vacíos, el chat y el link de ayuda quedan OCULTOS (no rompe nada).

export const TAWK_PROPERTY_ID = "6a3d1fdb7cb51a1d46e0d7a6";
export const TAWK_WIDGET_ID = "1jrvc8t7s";
export const HELP_CENTER_URL = "https://voras.tawk.help/";

export const tawkConfigured = () => Boolean(TAWK_PROPERTY_ID && TAWK_WIDGET_ID);
